// UserPage.js - Updated with better error handling
import React, { useState, useEffect } from "react";
import axios from "axios";
import Pagination from '../components/Pagination';
import "../styles/UserPage.css";

const UserPage = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setError("Authentication required");
          return;
        }

        const response = await axios.get( `${API_BASE_URL}/users`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        // Ensure data is in correct format
        if (!Array.isArray(response.data)) {
          throw new Error("Invalid data format from server");
        }

        setUsers(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching users:", error);
        setLoading(false);
        setError(error.response?.data?.message ||
                error.message ||
                "Failed to fetch users");

        if (error.response?.status === 403) {
          alert("You don't have permission to view users");
        }
      }
    };

    fetchUsers();
  }, []);

  const filteredUsers = users.filter(user => {
    const searchLower = searchTerm.toLowerCase();
    return (
      `${user.firstName} ${user.lastName}`.toLowerCase().includes(searchLower) ||
      (user.email?.toLowerCase().includes(searchLower)) ||
      (user.address?.streetAddress?.toLowerCase().includes(searchLower)) ||
      (user.address?.city?.toLowerCase().includes(searchLower)) ||
      (user.phoneNumber?.includes(searchTerm)) ||
      (user.username?.toLowerCase().includes(searchLower))
    );
  });

  // Pagination calculations
  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  if (loading) {
    return <div className="user-page-container">Loading users...</div>;
  }

  if (error) {
    return <div className="user-page-container">Error: {error}</div>;
  }

  return (
    <div className="user-page-container">
      <h1>Registered Users</h1>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search users by name, email, or address..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="user-table-container">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Ime</th>
              <th>Prezime</th>
              <th>Email</th>
              <th>Adresa</th>
              <th>Grad</th>
              <th>Poštanski Broj</th>
              <th>Broj Telefona</th>
              <th>Korisničko Ime</th>
            </tr>
          </thead>
          <tbody>
            {currentUsers.length > 0 ? (
              currentUsers.map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.firstName}</td>
                  <td>{user.lastName}</td>
                  <td>{user.email}</td>
                  <td>{user.address?.streetAddress || '-'}</td>
                  <td>{user.address?.city || '-'}</td>
                  <td>{user.address?.postalCode || '-'}</td>
                  <td>{user.phoneNumber || '-'}</td>
                  <td>{user.username}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="no-users">
                  {users.length === 0 ? "No users in system" : "No matching users found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {filteredUsers.length > itemsPerPage && (
        <Pagination
          currentPage={currentPage}
          totalPages={Math.ceil(filteredUsers.length / itemsPerPage)}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
  );
};

export default UserPage;